export default __webpack_public_path__ + "static/media/awash.fc85e725.png";